import { FC, MouseEventHandler, SetStateAction, Dispatch, ReactElement } from 'react';
import Slider from 'react-rangeslider';
import classnames from 'classnames';
import 'react-rangeslider/lib/index.css';
export interface IContentRangeCalculatorProps {
  step: number;
  minIndex: number;
  maxIndex: number;
  currentIndex: number;
  setCurrentIndex: Dispatch<SetStateAction<number>>;
  onDecreaseHandler: MouseEventHandler<HTMLButtonElement>;
  onIncreaseHandler: MouseEventHandler<HTMLButtonElement>;
  buttonMinus: string | ReactElement;
  buttonPlus: string | ReactElement;
  classContentButtonMinus?: string;
  classContentSlider?: string;
  classContentButtonPlus?: string;
}

const ContentRangeCalculator: FC<IContentRangeCalculatorProps> = (props) => {
  const {
    step,
    minIndex,
    maxIndex,
    currentIndex,
    setCurrentIndex,
    onDecreaseHandler,
    onIncreaseHandler,
    buttonMinus,
    buttonPlus,
    classContentButtonMinus,
    classContentSlider,
    classContentButtonPlus,
  } = props;

  return (
    <>
      <button
        type="button"
        onClick={onDecreaseHandler}
        className={classnames('range__content-btn', classContentButtonMinus)}
        disabled={currentIndex <= minIndex}
      >
        {buttonMinus}
      </button>

      <Slider
        tooltip={false}
        min={minIndex}
        max={maxIndex}
        step={step}
        value={currentIndex}
        onChange={setCurrentIndex}
        className={classnames('range__content-slider', classContentSlider)}
      />

      <button
        type="button"
        onClick={onIncreaseHandler}
        className={classnames('range__content-btn', classContentButtonPlus)}
        disabled={currentIndex >= maxIndex}
      >
        {buttonPlus}
      </button>
    </>
  );
};

export default ContentRangeCalculator;
